import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { LogoCompany } from '@atoms/Images';

type DataItem = {
    id: number;
    iconPath: string;
    label: string;
    pageLink: string;
    active: boolean;
};

const List = () => {
    const location = useLocation();
    const pathName = location.pathname;
    const data: DataItem[] = [
        {
            id: 1,
            label: 'ダッシュボード',
            pageLink: '/',
            iconPath: '/img/icon/home-32x32.png',
            active: pathName === '/' ? true : false,
        },
        {
            id: 2,
            label: '再点',
            pageLink: '/open',
            iconPath: '/img/icon/light-on-32x32.png',
            active: pathName.match(/\/open/) ? true : false,
        },
        {
            id: 3,
            label: '廃止',
            pageLink: '/close',
            iconPath: '/img/icon/light-off-32x32.png',
            active: pathName.match(/\/close/) ? true : false,
        }
        // , {
        //     id: 4,
        //     label: '不備',
        //     pageLink: '/error',
        //     iconPath: 'iconmonstr-error-8-32.png',
        //     active: pathName == '/error' ? true : false,
        // }
    ];
    return (
        <UL>
            {data.map(item => {
                return (
                    <LI key={item.id}>
                        <Link to={item.pageLink} className={item.active ? 'sidebarMenu__item sidebarMenu__item--active' : 'sidebarMenu__item'}>    
                            <img className='sidebarMenu__item__icon' src={item.iconPath} alt='' />
                            <span className='sidebarMenu__item__text'>{item.label}</span>
                        </Link>
                    </LI>
                );
            })}
        </UL>
    );
};

const Side = () => {
    /* state を保持するために localStorage にもセット */
    const storageKey = 'SIDEBAR_ACCODION_STATE';
    const defaultCloseFlg = localStorage.getItem(storageKey) === 'close' ? true : false;
    const [closeFlg, setActive] = useState(defaultCloseFlg);
    const sidebarEvent = () => {
        setActive(!closeFlg)
        localStorage.setItem(storageKey, closeFlg ? 'open' : 'close');
    }

    return (
        <DIV className={closeFlg ? 'sidebar sidebar--close' : 'sidebar'}>
            <h2 className='sidebar__title'>
                <span className='sidebar__title__text'>Menu</span>
                <span className='sidebar__title__trigger' onClick={sidebarEvent}></span>
            </h2>
            <List />
            <Link to='/' className='sidebar__logo'>
                <LogoCompany />
            </Link>
        </DIV>
    );
};

const DIV = styled.div`
`
const UL = styled.ul`
`
const LI = styled.ul`
`

export default Side;